import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_PPC_GRAPH } from './url-constants';

type PPCEndpointSpecification = ApiEndpointSpecification;
export const PPCEndpointSpecification: PPCEndpointSpecification = {

    url:DEVICE_PPC_GRAPH,
    method:HttpMethod.POST,
    requestParamsSchemaName: 'PPCGraphRequestParams',
    requestBodySchemaName: 'PPCGraphRequestBody',
    okResponseSchemaName: 'PPCGraphOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2
};

export const invokePPCApiData = Helpers.makeApiRequestFn<
Types.PPCGraphRequestParams,
Types.PPCGraphRequestBody,
Types.PPCGraphOkresponse
>(PPCEndpointSpecification);
